import React, { useCallback } from 'react'
import styled from 'styled-components'
import Button from 'react-bootstrap/Button'
import Card from 'react-bootstrap/Card'
import CardGroup from 'react-bootstrap/CardGroup'
import Col from 'react-bootstrap/Col'
import { AppCardProps } from './types'
import { getAppIconUrl, getAppDownloadUrl } from 'app/services/client'
import { onImageLoadError } from 'app/utils/fileUtils'
import { useSelector } from 'react-redux'
import { RootState } from 'app/state/types'
import { generatePath } from 'react-router-dom'
import { APP_ROUTES } from '../AppRouter/routes'

const AppCardImg = styled.img`
    width: 100%;
    align-self: center;
`

const AppCardBody = styled(Card.Body)`
    align-items: center;
    align-self: center;
    align-content: center;
    width: 100%;
`

const AppCardTitle = styled(Card.Title)`
    align-content: center;
    align-self: center;
    align-items: center;
    text-align: center;
    width: 100%;
`

const StyledButton = styled(Button)`
    width: 100%;
    margin-bottom: 5px;
    margin-right: 2px;
    margin-left: 2px;
`

const StyledButtonLink = styled.a`
    width: 100%;
    margin-bottom: 5px;
    margin-right: 2px;
    margin-left: 2px;
`

const CardCol = styled(Col)`
    margin-top: 6px;
    margin-bottom: 6px;
    padding-right: 6px;
    padding-left: 6px;
`

const AppCard = (props: AppCardProps) => {
    const { app, onDetailsClick } = props
    const { cdnInfo } = useSelector((state: RootState) => state.generalSlice)

    const getAppImageUrl = useCallback(() => {
        if (cdnInfo.imageCdn.enable && cdnInfo.imageCdn.url !== undefined) {
            const cdnLink = cdnInfo.imageCdn.url
            const cleanCdnLink =
                cdnLink.charAt(cdnLink.length - 1) === '/'
                    ? cdnLink.slice(0, -1)
                    : cdnLink
            return getAppIconUrl(app.id, cleanCdnLink)
        } else {
            return getAppIconUrl(app.id)
        }
    }, [cdnInfo, app.id])

    const getAppDownloadLink = useCallback(() => {
        let result = ''
        if (
            cdnInfo.applicationCdn.enable &&
            cdnInfo.applicationCdn.url !== undefined
        ) {
            const cdnLink = cdnInfo.applicationCdn.url
            const cleanCdnLink =
                cdnLink.charAt(cdnLink.length - 1) === '/'
                    ? cdnLink.slice(0, -1)
                    : cdnLink

            result = getAppDownloadUrl(
                app.id.toString(),
                app.latestApkId.toString(),
                cleanCdnLink,
            )
        } else {
            result = getAppDownloadUrl(
                app.id.toString(),
                app.latestApkId.toString(),
            )
        }
        return result
    }, [cdnInfo, app])

    const getDetailsLink = useCallback(() => {
        return generatePath(APP_ROUTES.APP_DETAILS, {
            id: app.id.toString(),
        })
    }, [app])

    return (
        <CardCol className="col-xl-2 col-md-4 col-sm-12 m-1 p-1">
            <Card className="app-card h-100">
                <AppCardImg
                    className="app-icon"
                    src={getAppImageUrl()}
                    onError={onImageLoadError}
                />
                <AppCardBody>
                    <CardGroup>
                        <StyledButton variant="info" href={getDetailsLink()}>
                            More info
                        </StyledButton>
                        <StyledButton
                            className="app-link"
                            variant="success"
                            href={getAppDownloadLink()}>
                            Download
                        </StyledButton>
                    </CardGroup>
                    <AppCardTitle>
                        <h5 className="app-name">{app.appName}</h5>
                    </AppCardTitle>
                </AppCardBody>
            </Card>
        </CardCol>
    )
}

export default AppCard
